import React, {useEffect, useState} from "react";
import "./App.css";
import {ApiDetails, KEY, loginState} from "./dummyData";
import {BrowserRouter as Router, Routes, Route, useLocation} from "react-router-dom";
import {MyFileBrowser} from "./components/Backup/Backup";
import Error404 from "./pages/404/Error404";
import UserList from "./pages/tenantList/UserList";
import Topbar from "./components/topbar/Topbar";
import PropertyList from "./pages/propertyList/PropertyList";
import CreateUser from "./pages/createUser/CreateUser";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import Details from "./pages/details/Details";
import CustomizedDialogs from "./components/dialog/DialogTemplate";
import Transactions from "./pages/transactions/transactions";
import MailList from "./pages/mailsList/MailList";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Analytics from "./pages/analytics/Analytics";
import Expenses from "./pages/Expenses/Expenses";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import {fetchEventSource} from "@microsoft/fetch-event-source";
import Message from "./pages/messages/Message";
import OldTenantList from "./pages/OldTenantList/OldTenantList";
import Events from "./pages/events/Events";
import Settings from "./pages/settings/Settings";
import TenantIssues from "./pages/tenantIssues/TenantIssues";
import VacatingTenantList from "./pages/vacatingTenantList/VacatingTenantList";
import TestSidebar from "./components/sidebar/TestSidebar";
import CryptoJS from "crypto-js";
import UserManagement from "./pages/AgentUserManagement/UserManagement";
import {ConfirmProvider} from "material-ui-confirm";
import HomeV2 from "./pages/Home/HomeV2";
import TenantV2 from "./pages/tenant/TenantV2";
import {SnackbarComponent} from "./components/SnackBar/SnackBar";
import PropertyV2 from "./pages/property/PropertyV2";
import LoginPageV2 from "./components/authentication/Login/LoginPageV2";
import LoginPage from "./pages/login/LoginPage";
import SignUp from "./pages/signup/SignUp";
import {Box} from "@mui/material";
import {ProSidebarProvider} from "react-pro-sidebar";
import InactivityPopup from "./components/inactivity/InactivityPopup";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function App() {
    const currentPath = window.location.pathname;
    const isLoginPage = currentPath === '/' || currentPath === '/login' || currentPath === '/signup';

    let myMapDetailsDecrypted;
    try {
        myMapDetailsDecrypted = CryptoJS.AES.decrypt(
            localStorage.getItem("myMap"),
            KEY
        );
    } catch (e) {
        myMapDetailsDecrypted = "";
    }

    const logout = () => {
        window.location.href = "/";
        localStorage.clear();
    };

    const [originalText] = React.useState(
        myMapDetailsDecrypted.toString(CryptoJS.enc.Utf8)
    );

    const [open, setOpen] = React.useState(loginState);
    const [backdrop, setBackDrop] = React.useState(null);
    const [message, setMessage] = React.useState("");
    const [severity, setSeverity] = React.useState();
    const [isLoggedIn, setLogin] = React.useState(
        !(
            window.location.pathname === "/" || window.location.pathname === "/signup"
        )
    );

    // Inactivity tracking states - COMMENTED OUT
    /*
    const [showInactivityPopup, setShowInactivityPopup] = useState(false);
    const [inactivityTimer, setInactivityTimer] = useState(null);
    const [popupTimer, setPopupTimer] = useState(null);

    const INACTIVITY_TIMEOUT = 10 * 60 * 10000000000000000000000000000000; // 10 minutes in milliseconds
    const POPUP_TIMEOUT = 30 * 1000; // 30 seconds in milliseconds
    */

    const changeLogin = () => {
        setLogin(true);
    };

    const [connectionMade, setConnectionMade] = React.useState(false);
    const [sidebarCollapsed, setSidebarCollapsed] = React.useState(false);


    const handleClick = (message) => {
        setMessage(message.text);
        setSeverity(message.type);
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    const openBackDrop = (message) => {
        if (message === "open") {
            setBackDrop(
                <div
                    style={{
                        position: "absolute",
                    }}
                >
                    <Backdrop
                        sx={{color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1}}
                        open={true}
                        onClick={null}
                    >
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                </div>
            );
        } else {
            setBackDrop();
        }
    };

    try {
        new Map(
            JSON.parse(originalText).map((object) => {
                return [object[0], object[1]];
            })
        );
    } catch (e) {
    }

    // SSE
    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchEventSource(
                    ApiDetails +
                    "pegasus/visionary/sse/" +
                    JSON.parse(originalText)[0][1],
                    {
                        method: "GET",
                        headers: {
                            Accept: "text/event-stream",
                            "Content-Type": "application/json",
                            token: "8d5b2e7c-36f4-4b45-b79b-61fc60eb905d",
                        },
                        onopen(res) {
                            if (res.ok && res.status === 200) {
                                setConnectionMade(true);
                            } else if (
                                res.status >= 400 &&
                                res.status < 500 &&
                                res.status !== 429
                            ) {
                                console.log("Client side error ", res);
                            }
                        },
                        onmessage(event) {
                            try {
                                let notifications = Array.from(JSON.parse(event.data));

                                // eslint-disable-next-line array-callback-return
                                notifications.map((notifi, index) => {
                                    let notification = new Map(Object.entries(notifi));
                                    if (notification.get("type") === "payment") {
                                        NotificationManager.success(
                                            notification.get("tenant_name") +
                                            " Credited " +
                                            notification.get("amount").toLocaleString("en-US", {
                                                style: "currency",
                                                currency: "KSH",
                                            }),
                                            "Payment Received",
                                            3000
                                        );
                                    } else if (
                                        notification.get("type") === "subscription payment"
                                    ) {
                                        NotificationManager.success(
                                            notification.get("message"),
                                            "Subscription",
                                            3000
                                        );
                                        setTimeout(() => {
                                            logout();
                                        }, 3500);
                                    } else if (notification.get("type") === "information") {
                                        NotificationManager.info(
                                            notification.get("message"),
                                            "Notice",
                                            3000
                                        );
                                    } else if (notification.get("type") === "warning") {
                                        NotificationManager.warning(
                                            notification.get("message"),
                                            "Warning",
                                            3000
                                        );
                                    } else if (notification.get("type") === "error") {
                                        NotificationManager.error(
                                            notification.get("message"),
                                            "Error",
                                            3000
                                        );
                                    }
                                });
                            } catch (e) {
                            }
                        },
                        onclose() {
                            console.log("Connection closed by the server retrying ... ");
                        },
                        onerror(err) {
                            console.log("There was an error from server", err);
                        },
                    }
                );
            } catch (e) {
            }
        };
        if (!connectionMade) {
            fetchData();
        }
    }, []);

    const [sidebarOpen, setSidebarOpen] = useState(true);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const {render, setForceRefresh} = Topbar(toggleSidebar);

    const [inactive, setInactive] = useState(false);

    // Reset inactivity timer function - COMMENTED OUT
    /*
    const resetInactivityTimer = () => {
        setInactive(false);
        clearTimeout(inactivityTimer);
        clearTimeout(popupTimer);
        setShowInactivityPopup(false);

        // Set a new inactivity timer
        const newTimer = setTimeout(() => {
            if (isLoggedIn && !["/", "/signup"].includes(window.location.pathname)) {
                setShowInactivityPopup(true);
                // Set popup timeout - if no action after 30 seconds, logout
                const newPopupTimer = setTimeout(() => {
                    logout();
                }, POPUP_TIMEOUT);
                setPopupTimer(newPopupTimer);
            }
        }, INACTIVITY_TIMEOUT);

        setInactivityTimer(newTimer);
    };

    // Handle user choosing to stay logged in
    const handleStayLoggedIn = () => {
        resetInactivityTimer();
    };
    */

    // Handle user activity events - COMMENTED OUT
    /*
    useEffect(() => {
        // Only set up inactivity tracking if logged in
        if (isLoggedIn && !["/", "/signup"].includes(window.location.pathname)) {
            // Initial timer setup
            resetInactivityTimer();

            // Add event listeners to detect user activity
            const activityEvents = [
                'mousedown', 'mousemove', 'keypress',
                'scroll', 'touchstart', 'click'
            ];

            // Add event listeners
            activityEvents.forEach(event => {
                window.addEventListener(event, resetInactivityTimer);
            });

            // Cleanup function
            return () => {
                clearTimeout(inactivityTimer);
                clearTimeout(popupTimer);
                activityEvents.forEach(event => {
                    window.removeEventListener(event, resetInactivityTimer);
                });
            };
        }
    }, [isLoggedIn]); // Re-run when login state changes
    */

    // Handle sidebar collapse state
    const handleSidebarCollapse = (collapsed) => {
        setSidebarCollapsed(collapsed);
    };

    // Calculate main content width based on sidebar state
    const contentWidth = sidebarCollapsed ? "calc(100% - 70px)" : "calc(100% - 250px)";
    const contentMargin = sidebarCollapsed ? "70px" : "250px";

    return (
        <ConfirmProvider>
            <div>
                <SnackbarComponent/>
                <NotificationContainer/>

                {/* Inactivity Popup - COMMENTED OUT */}
                {/*
                <InactivityPopup
                    open={showInactivityPopup}
                    onStay={handleStayLoggedIn}
                    onLogout={logout}
                    autoLogoutTime={30}
                />
                */}

                <Stack spacing={2} sx={{width: "100%"}}>
                    <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                        <Alert
                            onClose={handleClose}
                            severity={severity}
                            sx={{width: "100%"}}
                        >
                            {message}
                        </Alert>
                    </Snackbar>
                </Stack>
                {backdrop}
                <div className="App">
                    <Router>
                        {/* App Container using Flexbox */}
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                minHeight: "100vh",
                                width: "100%",
                                backgroundColor: "#f5f5f5"
                            }}
                        >
                            {/* Sidebar Section */}
                            {isLoggedIn && !["/", "/signup"].includes(window.location.pathname) && (
                                <ProSidebarProvider>
                                    <Box
                                        sx={{
                                            position: "fixed",
                                            height: "100vh",
                                            left: 0,
                                            top: 0,
                                            bottom: 0,
                                            zIndex: 1100,
                                        }}
                                    >
                                        <TestSidebar onCollapse={handleSidebarCollapse}/>
                                    </Box>
                                </ProSidebarProvider>
                            )}

                            {/* Main Content Area */}
                            <Box
                                sx={{
                                    flexGrow: 1,
                                    width: isLoggedIn && !["/", "/signup"].includes(window.location.pathname)
                                        ? contentWidth
                                        : "100%",
                                    marginLeft: isLoggedIn && !["/", "/signup"].includes(window.location.pathname)
                                        ? contentMargin
                                        : "0",
                                    transition: "margin 0.3s, width 0.3s",
                                    overflowX: "hidden",
                                }}
                            >
                                {/* Topbar */}
                                {isLoggedIn && <>{render}</>}

                                {/* Routes */}
                                <Box sx={{
                                    px: 2,
                                    pb: 2,
                                    pt: isLoginPage ? 0 : '84px',// This value should match the height of your topbar + some spacing
                                    mt: 0      // Remove any margin top that might be applied elsewhere
                                }}>
                                    <Routes>
                                        <Route
                                            path="/"
                                            element={
                                                <LoginPageV2
                                                    snackBar={(message) => {
                                                        handleClick(message);
                                                    }}
                                                    fn={() => changeLogin()}
                                                    topBar={() => changeLogin()}
                                                    refresh={(value) => {
                                                        setForceRefresh(value);
                                                    }}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/userManagement"
                                            element={
                                                <UserManagement
                                                    snackBar={(message) => {
                                                        handleClick(message);
                                                    }}
                                                    fn={() => changeLogin()}
                                                    topBar={() => changeLogin()}
                                                    refresh={(value) => {
                                                        setForceRefresh(value);
                                                    }}
                                                />
                                            }
                                        />

                                        <Route
                                            path="/login"
                                            element={
                                                <CustomizedDialogs>
                                                    <LoginPage
                                                        snackBar={(message) => handleClick(message)}
                                                        fn={() => changeLogin()}
                                                        topBar={() => changeLogin()}
                                                        refresh={(value) => {
                                                            setForceRefresh(value);
                                                        }}
                                                    />
                                                </CustomizedDialogs>
                                            }
                                        />

                                        <Route
                                            path="/tenantList"
                                            element={
                                                <UserList
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/vacatingTenantList"
                                            element={
                                                <VacatingTenantList
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/tenantIssues"
                                            element={
                                                <TenantIssues
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/oldTenantList"
                                            element={
                                                <OldTenantList
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/analytics"
                                            element={
                                                <Analytics
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/propertyList"
                                            element={
                                                <PropertyList
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    snackBar={(message) => handleClick(message)}
                                                    loginState={isLoggedIn}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/transactions"
                                            element={
                                                <Transactions
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    snackBar={(message) => handleClick(message)}
                                                    loginState={isLoggedIn}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/signup"
                                            element={
                                                <SignUp
                                                    snackBar={(message) => handleClick(message)}
                                                    fn={() => changeLogin()}
                                                    topBar={() => changeLogin()}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/tenant/:userId"
                                            element={
                                                <TenantV2
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/property/:propertyId"
                                            element={
                                                <PropertyV2
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/mailList"
                                            element={
                                                <MailList
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                    backrop={(message) => {
                                                        openBackDrop(message);
                                                    }}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/messages"
                                            element={
                                                <Message
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/expenses"
                                            element={
                                                <Expenses
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    snackBar={(message) => handleClick(message)}
                                                    backrop={(message) => {
                                                        openBackDrop(message);
                                                    }}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/user/create"
                                            element={<CreateUser loginState={isLoggedIn}/>}
                                        />
                                        <Route
                                            path="/home"
                                            element={
                                                <HomeV2
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    fn={() => changeLogin()}
                                                    loginState={isLoggedIn}
                                                    topBar={() => changeLogin()}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/events"
                                            element={
                                                <Events
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                    topBar={() => changeLogin()}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/settings"
                                            element={
                                                <Settings
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    refresh={(value) => {
                                                        setForceRefresh(value);
                                                    }}
                                                    snackBar={(message) => handleClick(message)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/details"
                                            element={
                                                <Details
                                                    refreshSideBar={() =>
                                                        setForceRefresh((forceRefresh) => !forceRefresh)
                                                    }
                                                    loginState={isLoggedIn}
                                                />
                                            }
                                        />
                                        <Route
                                            path="/backup"
                                            element={
                                                <MyFileBrowser
                                                    snackBar={(message) => handleClick(message)}
                                                    topBar={(value) => changeLogin(value)}
                                                />
                                            }
                                        />
                                        <Route
                                            path="*"
                                            element={
                                                <Error404
                                                    snackBar={(message) => {
                                                        handleClick(message);
                                                    }}
                                                    fn={() => changeLogin()}
                                                    topBar={() => changeLogin()}
                                                    refresh={(value) => {
                                                        setForceRefresh(value);
                                                    }}
                                                />
                                            }
                                        />
                                    </Routes>
                                </Box>
                            </Box>
                        </Box>
                    </Router>
                </div>
            </div>
        </ConfirmProvider>
    );
}

export default App;